import { render, staticRenderFns } from "./PageCorners.vue?vue&type=template&id=a9404f88&"
import script from "./PageCorners.vue?vue&type=script&lang=js&"
export * from "./PageCorners.vue?vue&type=script&lang=js&"
import style0 from "./PageCorners.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../royaumes/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports